import Config from '@/config'

const commonDefaultState = {
  isAuthenticated: false,
  canViewerShare: false,
  canEditPresentation: false,
  ahaSequenceNumber: 0,
  offsetTime: 0,
  isShowingSlideSearchPopup: false,
  isDocToQuizGeneratingBoxVisible: false,
  integrationPlatform: Config.integrationPlatform,
  isRenderedInsideIframe: window.top !== window.self,
  googleSlideActiveId: null,
  isCreatingGoogleSlide: false,
  isOfficeOnline: false,
  isPPTEditMode: false,
  addinPPTPlatform: null,
  addinPPTActiveView: 'edit',
  pptSlideLostFocus: false,
  isMiniBackstage: false,
  userHasHostedEvents: false,
}

export default commonDefaultState
